import { FC } from 'react'

export const CapterraTracker: FC = () => (
  <img src='https://ct.capterra.com/capterra_tracker.gif?vid=2107651&vkey=529158a55c8d509373c8307425cfa50e' alt='capterra tracker' />
)
